import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import TopBar from "./TopBar";
import { useAuth } from "../auth/AuthContext";
import LitisoftAnnouncementModal from "../components/LitisoftAnnouncementModal";

const styles = {
  outer: { display: "flex", height: "100%", background: "var(--bg-page)" },
  main:  { flex: 1, minWidth: 0, display: "flex", flexDirection: "column", overflow: "hidden", background: "var(--bg-page)" },
  body:  { flex: 1, overflow: "auto", padding: "24px 32px" },
  inner: { maxWidth: 1200, margin: "0 auto" },
};

export default function AppShell() {
  // feature/litisoft-mandatory-fields-v1 — sprint83.
  // One-time announcement for abogado users; self-gates on user role +
  // litisoft_announcement_seen_at, dismiss persists via /api/auth/.
  const { user, refreshUser } = useAuth();
  return (
    <div style={styles.outer}>
      <Sidebar />
      <div style={styles.main}>
        <TopBar />
        <div style={styles.body}>
          <div style={styles.inner}>
            <Outlet />
          </div>
        </div>
      </div>
      <LitisoftAnnouncementModal user={user} onDismissed={refreshUser} />
    </div>
  );
}
